import { AvailabilityDto } from '@shared/core/availabilities'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { GET_BOOKING_ONBOARDING_CACHE_KEY } from 'src/modules/user/hooks/use-booking-onboarding'
import { ApiService } from 'src/services/api.service'

export const GET_AVAILABILITY_CACHE_KEY = 'get-availability'

export function useAvailability(options?: UseQueryOptions<AvailabilityDto>) {
  const handleRetry = useHandleRetry()

  return useQuery([GET_AVAILABILITY_CACHE_KEY], () => ApiService.Availability.get(), {
    staleTime: 300000,
    retry: handleRetry,
    ...options,
  })
}

export function useUpdateAvailability() {
  const queryClient = useQueryClient()
  return useMutation((data: Partial<AvailabilityDto>) => ApiService.Availability.update(data), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_AVAILABILITY_CACHE_KEY])
      queryClient.invalidateQueries([GET_BOOKING_ONBOARDING_CACHE_KEY])
    },
  })
}
